var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessEnding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 426.667,
    height: 216.242,
    viewBox: "0 0 426.667 216.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_224",
    "data-name": "Rettangolo 224",
    width: 426.667,
    height: 216.242,
    fill: "#3f3d94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_352",
    "data-name": "Rettangolo 352",
    width: 273.422,
    height: 214.365,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Esito_positivo",
    "data-name": "Esito positivo",
    transform: "translate(39.214 -189.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_277",
    "data-name": "Raggruppa 277",
    transform: "translate(-39.214 189.809)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3281",
    "data-name": "Tracciato 3281",
    d: "M144.466,12.9A243.006,243.006,0,0,0,241.5,7.746c82.04-21.327,149.532,6.31,166.494,23.7,19.69,20.206,22.94,46.794,13.826,71.092s-29.625,46.486-54.2,65.784c-19.219,15.079-41.672,28.924-68.548,36.787-26.257,7.682-55.029,9.2-83.146,10.237-36.163,1.334-72.946,2.01-107.388-4.178-28.085-5.039-56.938-17.5-59.386-37.16-2.08-16.76,15.913-33.256,13.407-49.975C59.039,100.621,18.782,89.021,5.478,67.589-10.044,42.6,9.653,15.061,36.592,9.16,64.674,3.008,109.187,7.45,144.466,12.9",
    transform: "translate(0 0)",
    fill: "#3e3c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_714",
    "data-name": "Raggruppa 714",
    transform: "translate(34.578 189.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_713",
    "data-name": "Raggruppa 713",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3917",
    "data-name": "Tracciato 3917",
    d: "M139.7,61.113c-8.141-.629-13.6-.587-16.589-4.608-.743-1-3.755-5.512.922-18.2,9.379-25.46,32.932-38.33,33.407-37.786.318.364-9.16,7.257-10.367,17.74-.123,1.069-.42,3.85.69,4.378,1.595.758,4.671-3.8,8.065-7.142C166.14,5.343,182.372,3.484,183.249,5.356c.194.411-.355,1.011-3,3.456C168.6,19.6,163.778,22.263,161.591,28.626c-.6,1.739-1.741,5.068-.23,6.681,2.347,2.507,8.325-2.083,17.05-2.764.9-.072,14.235-.945,21.658,6.681,8.359,8.587,2.769,21.317,9.677,24.883,5.976,3.086,15.292-3.8,16.128-2.3.868,1.554-10.078,7.414-8.987,11.749,1.067,4.237,12.993,4.528,12.9,5.761-.1,1.432-16.081-.715-18.432,4.608-1.71,3.871,5.692,7.38,5.991,15.206.357,9.36-9.755,16.759-12.673,18.894-6.087,4.453-12.046,5.657-23.962,8.063-12.124,2.449-18.187,3.674-20.506,1.152-5.14-5.589,3.976-23.16,10.369-35.482,7.148-13.78-1.316-15.238-3-19.122-3.15-7.282-9.025-10.063-27.879-11.521",
    transform: "translate(42.955 0.177)",
    fill: "#8f250f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3918",
    "data-name": "Tracciato 3918",
    d: "M139.7,61.113c-8.141-.629-13.6-.587-16.589-4.608-.743-1-3.755-5.512.922-18.2,9.379-25.46,32.932-38.33,33.407-37.786.318.364-9.16,7.257-10.367,17.74-.123,1.069-.42,3.85.69,4.378,1.595.758,4.671-3.8,8.065-7.142C166.14,5.343,182.372,3.484,183.249,5.356c.194.411-.355,1.011-3,3.456C168.6,19.6,163.778,22.263,161.591,28.626c-.6,1.739-1.741,5.068-.23,6.681,2.347,2.507,8.325-2.083,17.05-2.764.9-.072,14.235-.945,21.658,6.681,8.359,8.587,2.769,21.317,9.677,24.883,5.976,3.086,15.292-3.8,16.128-2.3.868,1.554-10.078,7.414-8.987,11.749,1.067,4.237,12.993,4.528,12.9,5.761-.1,1.432-16.081-.715-18.432,4.608-1.71,3.871,5.692,7.38,5.991,15.206.357,9.36-9.755,16.759-12.673,18.894-6.087,4.453-12.046,5.657-23.962,8.063-12.124,2.449-18.187,3.674-20.506,1.152-5.14-5.589,3.976-23.16,10.369-35.482,7.148-13.78-1.316-15.238-3-19.122C164.432,65.351,158.557,62.571,139.7,61.113Z",
    transform: "translate(42.955 0.177)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3919",
    "data-name": "Tracciato 3919",
    d: "M128.529,99.674c-1.965.4-4.483.233-8.222,1.052-7.829,1.714-8.738,2.087-11.29,2.189-4.548.179-4.713-.891-11.059-1.268a50.367,50.367,0,0,0-11.406.462c-6.771,1.118-7.266,2.928-13.363,4.032-4.154.751-4.026-.07-13.478,0-8.2.06-12.3.089-17.05,1.267-6.037,1.494-6.462,2.955-11.636,3.456-5.2.5-5.211-.929-11.174-.577-6.791.4-9.523,2.42-12.442.462-.948-.636-1.669-1.922-3.111-4.493C1.317,100.937-.173,98.278.612,97.039c1.638-2.584,9.638,3.242,22.695,2.3a90.656,90.656,0,0,0,13.248-2.3c6.273-1.466,7.3-2.258,11.521-2.649a57.744,57.744,0,0,1,12.211.46c6.662.719,6.891,1.427,10.137,1.152,4-.338,4.675-1.5,10.139-2.764a51.636,51.636,0,0,1,10.367-1.267c7.439-.137,8.635,1.615,15.323.92,2.691-.279,2.849-.6,6.681-1.037a119.146,119.146,0,0,1,12.311-.734Z",
    transform: "translate(0.143 32.219)",
    fill: "#d5a100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3920",
    "data-name": "Tracciato 3920",
    d: "M80.377,92.46l4.968,5.425,2.3,1.959,0,1.785,7.527-1.49,1.49-.152-2.924-4.64a3.564,3.564,0,0,0-.5-.628l-3.314-3.394-3.64.271-3.013.367Z",
    transform: "translate(28.422 32.294)",
    fill: "#ea623a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3921",
    "data-name": "Tracciato 3921",
    d: "M60.358,92.767,65.351,98.2l2.3,1.959.026,1.423,6.371-.249a14.862,14.862,0,0,1,2.56.141l4.568.453L75.835,95.2l-2.88-3.457-3.2-.007-2.634.13-3.035.291Z",
    transform: "translate(21.343 32.441)",
    fill: "#ea623a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3922",
    "data-name": "Tracciato 3922",
    d: "M35.707,93.583l4.263,5.991,2.3,1.957,2.65,1.5.69,2.3c.677-.031,8.433.248,11.376.374a21.859,21.859,0,0,0,3.427-.273l4.206-1.022L60.36,99.457l-4.724-4.233-5.3-.893c-.027,0-7.276-.8-7.3-.807L39.681,93.4Z",
    transform: "translate(12.626 33.026)",
    fill: "#ea623a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3923",
    "data-name": "Tracciato 3923",
    d: "M17.8,105.273l-1.267-1.844-3.657-5.89,14.89-1.367,7.6,7.718.705,2.419-6.221,2.332c-3.484.893-3.513,1.6-8.092.3Z",
    transform: "translate(4.553 34.008)",
    fill: "#ea623a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3924",
    "data-name": "Tracciato 3924",
    d: "M.215,96.191c-1.253,1.6,3.2,11.3,7.337,13.421,1.869.96,4.51,1.178,5.53-.115.984-1.249.941-4.088-7.43-13.883l-2.1-.453c-.03-.007-.08-.015-.145-.023-.973-.129-1.681-.365-2.474.211Z",
    transform: "translate(0 33.586)",
    fill: "#ea623a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3925",
    "data-name": "Tracciato 3925",
    d: "M114.368,101.4,94.02,102.578a.577.577,0,0,1-.574-.792,10.5,10.5,0,0,0,.444-7.356l-.474-1.536a.57.57,0,0,0-.184-.275l-2.423-1.983a.574.574,0,0,1,.363-1.018h23.162a.575.575,0,0,1,.575.574v10.635a.575.575,0,0,1-.541.573",
    transform: "translate(32.036 31.69)",
    fill: "#f9ea8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3926",
    "data-name": "Tracciato 3926",
    d: "M135.171,112.662c-3.894-.441-9.623-1.021-15.725,1.729-10.495,4.727-15.967,16.537-14.343,18.144,1.5,1.481,9.611-5.121,10.369-4.147.586.753-3.641,5.486-8.813,9.85C93.606,149.25,77.64,155.279,74.172,156.554c-7.546,2.774-10.878,3.234-11.059,5.183-.371,3.984,12.919,8.742,22.636,10.887a87.488,87.488,0,0,0,29.2,1.382c44.794-5.077,70.8,8.077,76.378-2.764,4.827-9.378-11.235-25.816-5.356-38.535a34.712,34.712,0,0,0,2.937-10.887c.623-6.133-.822-8.773-1.382-9.677-.365-.59-2.363-3.816-5.358-4.493-6.864-1.553-10.034,12.326-20.044,14.343-8.65,1.742-11.461-7.573-26.957-9.332",
    transform: "translate(22.315 38.024)",
    fill: "#660b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3927",
    "data-name": "Tracciato 3927",
    d: "M135.171,112.662c-3.894-.441-9.623-1.021-15.725,1.729-10.495,4.727-15.967,16.537-14.343,18.144,1.5,1.481,9.611-5.121,10.369-4.147.586.753-3.641,5.486-8.813,9.85C93.606,149.25,77.64,155.279,74.172,156.554c-7.546,2.774-10.878,3.234-11.059,5.183-.371,3.984,12.919,8.742,22.636,10.887a87.488,87.488,0,0,0,29.2,1.382c44.794-5.077,70.8,8.077,76.378-2.764,4.827-9.378-11.235-25.816-5.356-38.535a34.712,34.712,0,0,0,2.937-10.887c.623-6.133-.822-8.773-1.382-9.677-.365-.59-2.363-3.816-5.358-4.493-6.864-1.553-10.034,12.326-20.044,14.343C153.479,123.736,150.667,114.42,135.171,112.662Z",
    transform: "translate(22.315 38.024)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3928",
    "data-name": "Tracciato 3928",
    d: "M133.138,114.441c-5.4-1.324-10.439,3.821-12.959,6.393-3.8,3.879-5.041,7.289-6.913,10.887-5.6,10.761-13.781,17.269-19.007,21.428-11.364,9.039-19.868,9.833-19.527,13.306.315,3.215,8,6.524,15.38,6.048,12.032-.777,13.144-10.955,36.634-31.968,8.17-7.311,14.423-11.793,13.651-17.8a10.319,10.319,0,0,0-7.258-8.295",
    transform: "translate(26.422 40.392)",
    fill: "#9ab7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3929",
    "data-name": "Tracciato 3929",
    d: "M133.138,114.441c-5.4-1.324-10.439,3.821-12.959,6.393-3.8,3.879-5.041,7.289-6.913,10.887-5.6,10.761-13.781,17.269-19.007,21.428-11.364,9.039-19.868,9.833-19.527,13.306.315,3.215,8,6.524,15.38,6.048,12.032-.777,13.144-10.955,36.634-31.968,8.17-7.311,14.423-11.793,13.651-17.8A10.319,10.319,0,0,0,133.138,114.441Z",
    transform: "translate(26.422 40.392)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3930",
    "data-name": "Tracciato 3930",
    d: "M131.212,59.438c-7.43,1.729-7.058,7.083-7.085,7.43-.348,4.482,1.561,8.606,1.844,14.055.19,3.664.126,3.278-.462,4.609a19.849,19.849,0,0,1-6.681,8.063c-1.389,1.022-6.982,5.134-13.824,4.378-5.347-.592-8.2-3.8-10.829-2.074A5.712,5.712,0,0,0,92.1,99.355c-.43,1.785-.253,4.294,1.152,5.761,2.185,2.278,5.515.138,12.9,1.152,1.36.187,7.18.984,7.373,2.764.234,2.154-8.026,3.226-8.525,7.373-.287,2.39,2.162,4.489,2.3,4.608a8.612,8.612,0,0,0,5.3,1.614c2.784.21,10.608.8,13.364,4.608,2.4,3.314,1.662,10.038-1.152,13.824-.69.927-1.385,1.516-1.383,2.534,0,3.09,6.407,5.394,8.065,5.991,10.378,3.735,31.874,1.528,40.09-11.981,5.314-8.738,4.786-21.732,10.137-22.58.811-.129,1.52.06,3.687-.23,2.215-.3,5.138-.688,7.6-2.305a11.612,11.612,0,0,0,5.3-9.446c-.018-3.613-1.947-8.35-5.76-9.447-4.257-1.225-8.942,2.642-10.829,5.991-1.183,2.1-1.351,4.15-2.074,4.146-1,0-1.887-3.972-2.074-5.76-1.352-12.98,22.2-24.291,20.046-29.031-1.492-3.288-14.029-.509-14.285-1.842-.286-1.49,15.632-3.53,16.128-8.295.589-5.661-20.965-11.583-24.193-12.442-1.993-.529-25.734-6.667-30.643.922-.83,1.282-1.628,3.739-4.147,4.839-2.583,1.128-3.571.345-5.99,1.382,0,0-5.012,1.67-4.147,6.51",
    transform: "translate(32.495 15.389)",
    fill: "#d8ab92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3931",
    "data-name": "Tracciato 3931",
    d: "M131.212,59.438c-7.43,1.729-7.058,7.083-7.085,7.43-.348,4.482,1.561,8.606,1.844,14.055.19,3.664.126,3.278-.462,4.609a19.849,19.849,0,0,1-6.681,8.063c-1.389,1.022-6.982,5.134-13.824,4.378-5.347-.592-8.2-3.8-10.829-2.074A5.712,5.712,0,0,0,92.1,99.355c-.43,1.785-.253,4.294,1.152,5.761,2.185,2.278,5.515.138,12.9,1.152,1.36.187,7.18.984,7.373,2.764.234,2.154-8.026,3.226-8.525,7.373-.287,2.39,2.162,4.489,2.3,4.608a8.612,8.612,0,0,0,5.3,1.614c2.784.21,10.608.8,13.364,4.608,2.4,3.314,1.662,10.038-1.152,13.824-.69.927-1.385,1.516-1.383,2.534,0,3.09,6.407,5.394,8.065,5.991,10.378,3.735,31.874,1.528,40.09-11.981,5.314-8.738,4.786-21.732,10.137-22.58.811-.129,1.52.06,3.687-.23,2.215-.3,5.138-.688,7.6-2.305a11.612,11.612,0,0,0,5.3-9.446c-.018-3.613-1.947-8.35-5.76-9.447-4.257-1.225-8.942,2.642-10.829,5.991-1.183,2.1-1.351,4.15-2.074,4.146-1,0-1.887-3.972-2.074-5.76-1.352-12.98,22.2-24.291,20.046-29.031-1.492-3.288-14.029-.509-14.285-1.842-.286-1.49,15.632-3.53,16.128-8.295.589-5.661-20.965-11.583-24.193-12.442-1.993-.529-25.734-6.667-30.643.922-.83,1.282-1.628,3.739-4.147,4.839-2.583,1.128-3.571.345-5.99,1.382,0,0-5.012,1.67-4.147,6.51",
    transform: "translate(32.495 15.389)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3932",
    "data-name": "Tracciato 3932",
    d: "M131.421,63.383a9.95,9.95,0,0,0-1.382,3.686c-.6,4.717,3.369,9.389,6.912,11.521,7.67,4.614,19.122.805,19.584-2.765.283-2.189-4.976-6.779-23.962-13.133",
    transform: "translate(45.962 22.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3933",
    "data-name": "Tracciato 3933",
    d: "M139.006,57.874a17.655,17.655,0,0,0-7.6,7.143,9.941,9.941,0,0,0-1.382,3.686c-.6,4.717,3.369,9.389,6.912,11.521,7.67,4.614,19.123.805,19.584-2.765.283-2.189-4.976-6.78-23.962-13.133",
    transform: "translate(45.956 20.465)",
    fill: "none",
    stroke: "#161615",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3934",
    "data-name": "Tracciato 3934",
    d: "M134.487,67.72c-.791-5.332-17.28-10.714-19.354-5.76-1.605,3.836,1.619,9.638,7.6,11.981,3.995,1.563,4.91-1.664,7.028-3.456,1.626-1.378,4.995-.933,4.723-2.765",
    transform: "translate(40.568 21.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3935",
    "data-name": "Tracciato 3935",
    d: "M134.487,67.72c-.791-5.332-17.28-10.714-19.354-5.76-1.605,3.836,1.619,9.638,7.6,11.981,3.995,1.563,4.91-1.664,7.028-3.456C131.39,69.108,134.759,69.553,134.487,67.72Z",
    transform: "translate(40.568 21.218)",
    fill: "none",
    stroke: "#050606",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3936",
    "data-name": "Tracciato 3936",
    d: "M121.707,82.11a10.35,10.35,0,0,1-6.477,0c-4.388-1.557-7.615-6.568-6.237-9.677,1.344-3.035,6.874-3.8,10.316-3.456,4.286.425,6.569,2.683,8.876,1.382,1.492-.841,1.221-2.168,2.879-3.456,1.965-1.527,4.671-1.467,6.717-1.152",
    transform: "translate(38.427 23.187)",
    fill: "#d8ab92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3937",
    "data-name": "Tracciato 3937",
    d: "M121.707,82.11a10.35,10.35,0,0,1-6.477,0c-4.388-1.557-7.615-6.568-6.237-9.677,1.344-3.035,6.874-3.8,10.316-3.456,4.286.425,6.569,2.683,8.876,1.382,1.492-.841,1.221-2.168,2.879-3.456,1.965-1.527,4.671-1.467,6.717-1.152",
    transform: "translate(38.427 23.187)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3938",
    "data-name": "Tracciato 3938",
    d: "M123.229,61.961c0,1.129-1.341,2.045-3,2.045s-3-.916-3-2.045,1.341-2.045,3-2.045,3,.916,3,2.045",
    transform: "translate(41.457 21.187)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3939",
    "data-name": "Tracciato 3939",
    d: "M139.825,66.174c0,1.129-1.341,2.045-3,2.045s-3-.916-3-2.045,1.341-2.045,3-2.045,3,.916,3,2.045",
    transform: "translate(47.325 22.677)",
    fill: "#161615"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessEnding);
export default __webpack_public_path__ + "static/media/success-ending.2d57fc75fa6a44e03b95c7e293fcae60.svg";
export { ForwardRef as ReactComponent };